import React from 'react';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { PepperMoneyLogo } from './peppermoney-logo';
import * as styles from './peppermoney.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var PepperMoney = _ref => {
  var href = _ref.href,
    _onClick = _ref.onClick,
    title = _ref.title,
    subtitle = _ref.subtitle;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  if (!title || !href) {
    return null;
  }
  return ___EmotionJSX("a", {
    href: href,
    css: styles.pepperMoney,
    onClick: () => {
      sendEvent('peppermoney-cta-click');
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, ___EmotionJSX("div", {
    css: styles.body
  }, ___EmotionJSX("div", {
    css: styles.copy
  }, ___EmotionJSX("div", {
    css: styles.line1
  }, title), subtitle ? ___EmotionJSX("div", {
    css: styles.line2
  }, subtitle) : null), ___EmotionJSX("div", {
    css: styles.logoContainer
  }, ___EmotionJSX(PepperMoneyLogo, null))), ___EmotionJSX("div", {
    css: styles.chevronFrame
  }, ___EmotionJSX(ChevronRightIcon, null)));
};